module.exports = __webpack_public_path__ + "static/media/bf7.4153c877.png";